import React from 'react';

const legendItems = [
    { color: 'bg-gray-500', label: 'In Parking' },
    { color: 'bg-orange-500', label: 'To Pickup' },
    { color: 'bg-red-500', label: 'With Passager' },
    { color: 'bg-green-400', label: 'Free Taxi' },
];

const MapLegend = () => {
    return (
        <div className="flex flex-col lg:flex-row items-center gap-6 bg-white pl-5 pr-5 pt-2 pb-2 rounded-xl shadow-md">
            {legendItems.map((item, index) => (
                <div key={index} className="flex items-center gap-2">
                    <span className={`w-4 h-4 rounded-full ${item.color}`} />
                    <span className="text-sm text-gray-800">{item.label}</span>
                </div>
            ))}
        </div>
    );
};

export default MapLegend;
